import React, { useEffect, useState } from "react";
import { getAllTrips } from "../../features/trips/trip.api";
import List from "./TripList";
import { MenuItem, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DatePicker } from 'antd';
import { TRIP_FILTERS } from "../../shared/constants";
import './trips.css'
import "react-datepicker/dist/react-datepicker.css";
const Trips = () => {
    const [trips, setTrips] = useState([])
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(100)
    const [total, setTotal] = useState(0)
    const [searchTerm, setSearchTerm] = useState('')
    const [filters, setFilters] = useState({
        status: "",
        transportDate: null
    })
    const navigate = useNavigate()
    const { RangePicker } = DatePicker;

    const fetchTrips = async (currentPage = page) => {
        const query = {
            limit: rowsPerPage,
            page: currentPage + 1
        };

        // Only add search to query if it has 3 or more characters
        if (searchTerm && searchTerm.length >= 3) {
            query.search = searchTerm;
        }

        if (filters?.status) {
            query.workflowText = filters?.status;
        }
        if (filters.transportDate && filters.transportDate[0] && filters.transportDate[1]) {
            const startDate = filters.transportDate[0].startOf('day').toISOString();
            const endDate = filters.transportDate[1].endOf('day').toISOString();

            query.startDate = startDate;
            query.endDate = endDate;
        }
        const tripData = await getAllTrips(query);
        setTrips(tripData);
        setTotal(tripData?.totalResults);
    }

    useEffect(() => {
        if (searchTerm === '' || searchTerm.length >= 3) {
            const delay = searchTerm ? 500 : 0;

            const timer = setTimeout(() => {
                fetchTrips();
            }, delay);

            return () => clearTimeout(timer);
        }
    }, [rowsPerPage, page, searchTerm, filters]);

    const handleNavigate = () => {
        navigate('/trips-add')
    }
    const handleFilterChange = (e) => {
        const { name, value } = e.target
        setFilters((prev) => ({
            ...prev,
            [name]: value
        }))
        setPage(0)
    }
    const handleResetFilters = () => {
        setFilters({
            transportDate: null,
            status: ""
        })
        setSearchTerm('')
    }
    const isFilterEmpty =
        !filters?.transportDate &&
        (!filters?.status || filters?.status === '') &&
        !searchTerm;
    return (
        <>
            <div className="flex justify-between items-center gap-4 mb-6">
                {/* Left Section - Search and Status Filter */}
                <div className="flex items-center gap-4">
                    <TextField
                        id="outlined-search"
                        label="Search"
                        type="search"
                        name="search"
                        value={searchTerm}
                        placeholder="Search by Ticket / Order Id"
                        onChange={(e) => setSearchTerm(e.target.value)}
                        size="small"
                        className="w-48" // Width for search input
                    />

                    <TextField
                        id="filled-select-currency"
                        select
                        label="Status"
                        // helperText="Please select to filter against WorkFlow text"
                        size="small"
                        name="status"
                        value={filters?.status}
                        onChange={(e) => handleFilterChange(e)}
                        className="w-48" // Width for status filter
                    >
                        <MenuItem value=''>Select Status</MenuItem>
                        {TRIP_FILTERS.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>

                    {/* DatePicker */}
                    <div>
                        <RangePicker
                            size="large"
                            onChange={(dates) =>
                                handleFilterChange({
                                    target: {
                                        name: 'transportDate',
                                        value: dates
                                    }
                                })
                            }
                            value={filters.transportDate}
                            format="YYYY-MM-DD"
                        />
                    </div>
                    <div className="flex items-center">
                        <button
                            onClick={handleResetFilters}
                            disabled={isFilterEmpty}
                            className={`text-sm font-semibold p-2 rounded-md border-2 transition-colors duration-300
  ${isFilterEmpty
                                    ? 'bg-white text-gray-400 border-gray-300 cursor-not-allowed'
                                    : 'bg-white text-primary border-primary hover:bg-primary hover:text-white hover:border-primary cursor-pointer'
                                }
`}
                        >
                            Reset
                        </button>
                    </div>
                </div>

                {/* Right Section - Add Trips Button */}
                <div className="flex items-center">
                    <button
                        onClick={handleNavigate}
                        className="text-sm font-semibold p-2 rounded-md bg-primary text-white border-2 border-transparent hover:bg-white hover:text-primary hover:border-primary transition-colors duration-300"
                    >
                        Add Trips
                    </button>
                </div>
            </div>


            <List
                rows={trips?.data}
                rowsPerPage={rowsPerPage}
                totalCount={total}
                page={page}
                setRowsPerPage={setRowsPerPage}
                fetchTrips={fetchTrips}
                setPage={setPage}
            />
        </>
    )
}
export default Trips 